module.exports = __webpack_public_path__ + "img/gpx_icon.1c99995.png";